import { colors } from '../../constants';
const MuiButton = {
  sizeLarge: {
    padding: '14px 23px',
    lineHeight: 1.25
  },
  sizeSmall: {
    padding: '10px 23px'
  },
  root: {
    lineHeight: 1.3,
    borderRadius: 25,
    padding: '12px 23px'
  },
  text: {
    padding: '10px 23px'
  },
  contained: {
    borderRadius: 25,
    '&$disabled': {
      color: colors.commonColors.white
    }
  },
  outlined: {
    borderRadius: 25,
    borderWidth: 2,
    padding: '10px 23px',
    lineHeight: 1.35,
    borderColor: 'currentColor',
    '&:disabled': {
      borderWidth: 2
    }
  },
  outlinedPrimary: {
    borderWidth: 2,
    '&:hover': {
      borderWidth: 2
    },
    '&:disabled': {
      borderWidth: 2
    }
  },
  outlinedSecondary: {
    borderWidth: 2,
    '&:hover': {
      borderWidth: 2
    },
    '&:disabled': {
      borderWidth: 2
    }
  }
};
export default MuiButton;